// extracted by mini-css-extract-plugin
module.exports = {"instructionsVideo":"InstructionsVideo_instructionsVideo__ywMoV"};